import React from 'react';
import {
	NavigareAccountingCodes,
} from '@shared/utils/constants';
import { formatCurrency } from '@shared/utils/currency';
import type { FixtureCounterpartyProps } from '@api/models/fixture-counterparty';
import type { TransformedExpenses } from '@api/utils/getTransformedVoyageExpenses';
import { formatDate } from '@client/utils/formatDate';
import getMeratusReceivableAccountCodeItem from '@client/utils/meratus/getMeratusReceivableAccountCodeItem';
import StateTag from '@client/components/StateTag';

const getReceivableItems = (
	expense: TransformedExpenses & { charterer?: FixtureCounterpartyProps | undefined },
	showNavigareAccountCodeOverride = false,
	showMeratusAccountCode = false,
) => (expense.receivable == null ? [] : [
	{
		label: 'Rebillable',
		key: '',
		type: 'text',
		render: () => (
			<StateTag
				state={expense.receivable?.state ?? 'Not created'}
			/>
		),
	},
	{
		key: 'amount',
		label: 'Amount',
		value: expense.receivable.amount,
		inputProps: {
			currency: expense.receivable.currency,
		},
		render: (
			c: any,
		) => formatCurrency(c.value, expense.receivable!.currency),
		type: 'currency',
		editable: true,
	},
	{
		label: 'Description',
		key: 'itemDescription',
		type: 'text',
		value: expense.receivable.itemDescription,
		editable: true,
	},
	{
		label: 'Created At',
		type: 'text',
		value: formatDate(expense.receivable.createdAt),
	},
	...(showMeratusAccountCode ? [
		getMeratusReceivableAccountCodeItem(expense.receivable.accountCodeOverride == null),
	] : []),
	...(showNavigareAccountCodeOverride && !showMeratusAccountCode ? [{
		key: 'accountCodeOverride',
		label: 'Account',
		editable: true,
		type: 'select' as const,
		value: expense.receivable.accountCodeOverride,
		options: Object.keys(NavigareAccountingCodes).map((code) => ({
			label: `${NavigareAccountingCodes[code as unknown as keyof typeof NavigareAccountingCodes]} (${code})`,
			value: code,
		})),
		render: (entry: { value?: string | null }) => (
			entry.value == null ? '-' :
				`${NavigareAccountingCodes[entry.value as unknown as keyof typeof NavigareAccountingCodes]} (${entry.value})`
		),
	}] : []),
	{
		key: 'note',
		label: 'Note',
		value: expense.receivable.note,
		editable: true,
		type: 'textarea',
	},
]);

export default getReceivableItems;
